<template>
  <div>
    <p class="text-danger" style="text-align:center;font-size:18px">
      換行做分隔
    </p>
    <div class="labelWrap">
      <label>請輸入允許手動提交代付商戶</label>
      <el-input type="textarea" :rows="5" v-model="dataData[0].user_ids">
      </el-input>
    </div>
    <div class="labelWrap">
      <label>請輸入允許手動變更餘額的代理</label>
      <el-input type="textarea" :rows="5" v-model="dataData[1].user_ids">
      </el-input>
    </div>
    <div class="labelWrap">
      <label>代付新版簽名規則商戶</label>
      <el-input type="textarea" :rows="5" v-model="dataData[2].user_ids">
      </el-input>
    </div>
    <div class="labelWrap">
      <label>隱藏提現選單</label>
      <label></label>
      <el-input type="textarea" :rows="5" v-model="dataData[3].user_ids">
      </el-input>
    </div>
    <div class="labelWrap">
      <label
        >代付及提現三方駁回時,訂單改為未處理(不自動駁回訂單) (代理名單)</label
      >
      <el-input type="textarea" :rows="5" v-model="dataData[4].user_ids">
      </el-input>
    </div>
    <el-button size="mini" type="primary" @click="setData">確認送出</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataData: [
        { type: 0, user_ids: "" },
        { type: 1, user_ids: "" },
        { type: 2, user_ids: "" },
        { type: 3, user_ids: "" },
        { type: 4, user_ids: "" }
      ]
    };
  },
  methods: {
    getData() {
      this.$http.get(`/back/payment/settings`).then(res => {
        if (res.data.code == 0) {
          res.data.data.forEach(e => {
            this.dataData.forEach((t, index) => {
              if (e.type == t.type) {
                if (e.user_ids.length) {
                  this.dataData[index].user_ids = e.user_ids
                    .join()
                    .replace(/,/g, "\n");
                } else {
                  this.dataData[index].user_ids = "";
                }
              }
            });
          });
        }
      });
    },
    setData() {
      let data = JSON.parse(JSON.stringify(this.dataData));
      let arr = [];
      let send = true;
      data.forEach(e => {
        arr = [];
        if (e.user_ids != "") {
          e.user_ids.split("\n").forEach(num => {
            if (num.length != 0 && !Number(num)) {
              send = false;
              this.$message.error("請檢查");
              return;
            }
            if (num != "") {
              arr.push(num.trim());
            }
          });
        }
        e.user_ids = arr;
      });
      if (!send) return;
      this.$http.post(`/back/payment/settings`, data).then(res => {
        if (res.data.code == 0) {
          this.getData();
          this.$message.success("設置成功");
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.labelWrap {
  margin-bottom: 10px;
  label {
    font-size: 16px;
  }
  .el-textarea {
    margin-top: 10px;
  }
}
</style>
